import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InMemoryCacheService } from '../cache/in-memory-cache.service';
// import { NotificationComponent } from '../../modals/notification/notification.component';
import { ErrorService } from './error.service';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Pagination } from '../models/pagination';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(private cache: InMemoryCacheService, private errorService: ErrorService) { }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if (currentUser && new Date(currentUser.expiration) < new Date()) {
      localStorage.removeItem('currentUser');
      location.reload();
    }

  // Attach token to all requests except account endpoints and blob storage GETs
  const isAccountRequest = request.url.includes('/account');
  const isBlobGet = request.url.includes('blob.core.windows.net') && request.method.toUpperCase() === 'GET';
  const organizationId = this.cache?.organization?.id
    ?? this.cache?.user?.currentOrganizationId
    ?? this.cache?.auth?.user?.user?.currentOrganizationId;
  const shouldAttachOrgId = organizationId != null && !isBlobGet;

  // Examples:
  // - GET https://insightgainerdev.blob.core.windows.net/...  => no token
  // - DELETE https://localhost:44341/api/v1/Upload?...        => token added
  const token = this.cache?.auth?.token;
  if ((!isAccountRequest && !isBlobGet && token) || shouldAttachOrgId) {
    const headers: Record<string, string> = {};
    if (!isAccountRequest && !isBlobGet && token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    if (shouldAttachOrgId) {
      headers['x-org-id'] = String(organizationId);
    }
    request = request.clone({
      setHeaders: headers
    });
  }


    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Prefer standard X-Pagination header containing JSON
          const pagination = event.headers.get('x-pagination');
          if (pagination) {
            try {
              this.cache.pagination = JSON.parse(pagination);
            } catch {
              // ignore JSON parse errors
            }
          } else {
            // Fallback to individual pagination headers if present
            const total = event.headers.get('TotalCount');
            const size = event.headers.get('PageSize');
            const current = event.headers.get('CurrentPage');
            const totalPages = event.headers.get('TotalPages');
            const hasNext = event.headers.get('HasNext');
            const hasPrev = event.headers.get('HasPrevious');
            if (total || size || current || totalPages) {
              this.cache.pagination = {
                TotalCount: total ? Number(total) : 0,
                PageSize: size ? Number(size) : 0,
                CurrentPage: current ? Number(current) : 1,
                TotalPages: totalPages ? Number(totalPages) : 0,
                HasNext: hasNext ? (hasNext.toLowerCase() === 'true') : undefined,
                HasPrevious: hasPrev ? (hasPrev.toLowerCase() === 'true') : undefined
              } as any;
            }
          }
          //
        }

        return event;
    }),
    catchError((error: HttpErrorResponse) => {
        if (error.status === 500) {
          // const modalRef = this.modalService.open(NotificationComponent);
          // modalRef.componentInstance.title = 'Server Error';
          // modalRef.componentInstance.denyBtnLabel = 'OK';
          // modalRef.componentInstance.message = 'Please contact system administrator.';
        } else {
          this.errorService.handleError(error);
        }

        return throwError(error);
    }));
  }
}
